export default {
      id: "icon-resource-usage",
      viewBox: "0 0 17.07 17.508",
      url: __webpack_public_path__ + "img/icons.c8a27ec6.svg#icon-resource",
      toString: function () {
        return this.url;
      }
    }